/*
 *Headers for the admin list sortable list
 */

define([
  "backbone",
  "jquery",
  "underscore",
  "messaging/messenger",
  "modules/shared/basicAdminList/template/deleteButton.html",
  "modules/shared/sortableList/sortableListModel",
], function (Backbone, $, _, Messenger, DeleteButtonTemplate, SortableListModel) {
  "use strict";

  //Request for the headers of the basic admin list, obtaining the attributes from the areaModel
  Messenger.reqres.setHandler("admin:list:headers", function (areaModel) {
    var Header = SortableListModel.headerModel;
    var allowEdit = !!areaModel.get("editModalTitle");
    var columns = [
      new Header({
        headerName: $.t("admin.headers.name"),
        modelAttribute: areaModel.get("nameAttribute"),
        selectable: allowEdit,
        sortable: true,
        textField: true,
      }),
    ];
    if (areaModel.get("descriptionAttribute")) {
      columns.push(
        new Header({
          headerName: $.t("admin.headers.description"),
          modelAttribute: areaModel.get("descriptionAttribute"),
          sortable: true,
          textField: true,
        }),
      );
    }
    if (areaModel.get("deleteTooltip")) {
      //replace the tooltip with the i18n'ed key taken from areaModel
      var _template = DeleteButtonTemplate.replace(
        "<%- deleteTooltip %>",
        areaModel.get("deleteTooltip"),
      );
      columns.push(
        new Header({
          headerName: "",
          modelAttribute: areaModel.get("nameAttribute"),
          width: "15px",
          customHtml: _template,
        }),
      );
    }
    return new Backbone.Collection(columns);
  });
});
